export default __webpack_public_path__ + "static/media/Substrates-Training.b5d0db56.svg";